const history = require("history").createBrowserHistory;
export default history({ forceRefresh: true });
